module.exports = __webpack_public_path__ + "static/Jawadur Rashid.a33b9fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Jawadur Rashid.jpg
// module id = 1217
// module chunks = 6166952557895